import { useState, useEffect } from "react";

const SearchBar = ({
  value = "",
  onChange,
  placeholder = "Cari data...",
  delay = 300,
  className = "",
}) => {
  const [keyword, setKeyword] = useState(value);

  useEffect(() => {
    setKeyword(value);
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onChange) {
        onChange(keyword);
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [keyword, delay, onChange]);

  const handleClear = () => {
    setKeyword("");
    if (onChange) {
      onChange("");
    }
  };

  return (
    <div className={`ui-searchbar ${className}`.trim()}>
      <span className="ui-searchbar__icon" aria-hidden="true">
        🔍
      </span>

      <input
        type="text"
        className="ui-searchbar__input"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
      />

      {keyword && (
        <button
          type="button"
          className="ui-searchbar__clear"
          onClick={handleClear}
          aria-label="Hapus pencarian"
          title="Hapus pencarian"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default SearchBar;